<template>
  <!-- Table Container Card -->
  <b-card id="page-memberships" no-body class="mb-0 p-2">
    <b-card-header
      class="pl-0 pr-0 d-flex align-items-between justify-content-start"
    >
      <b-col cols="12" md="4">
        <b-card-title
          ><h2>{{ $t(label("title")) }}</h2></b-card-title
        >
      </b-col>

      <b-tooltip
        placement="top"
        target="tooltip-create"
        triggers="hover"
        @click="onInfo"
      >
        <strong>
          <feather-icon icon="ExternalLinkIcon" class="mr-25 mt-0" />
          Ver tutorial
        </strong>
        <span> </span>
      </b-tooltip>
    </b-card-header>
    <Filterss
      :fields="fieldsToFilters"
      :model="model"
      @filter-applied="applyFilters"
      @filter-reset="resetFilters"
    />
    <b-table
      id="memberships-table"
      responsive
      :head-variant="headVariant"
      :striped="striped"
      :bordered="bordered"
      :borderless="borderless"
      :outlined="outlined"
      :per-page="perPage"
      :busy="loading"
      :items="items"
      :fields="fields"
      class="d-none d-md-table shadow-sm !rounded"
    >
      <!-- A custom formatted header cell for field 'name' -->
      <template #head()="data">
        <span class="text-black">{{
          $t(labelHeader(data.label.toLowerCase()))
        }}</span>
      </template>

      <template #cell(name)="data">
        <slot name="cell-nameSubscription" :data="data">
          {{ data.item.nameSubscription || "N/A" }}
        </slot>
      </template>

      <template #cell(nameCompany)="data">
        <slot name="cell-nameCompany" :data="data">
          {{ data.item.nameCompany || "N/A" }}
        </slot>
      </template>

      <template #cell(active)="data">
        <slot name="cell-active" :data="data">
          <b-badge pill :variant="tagsColor(data.item.active)">
            <span>{{ data.item.active ? "Activo" : "Inactivo" }}</span>
          </b-badge>
        </slot>
      </template>

      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle ml-50"></b-spinner>
          <strong>{{ $t("loading") }}...</strong>
        </div>
      </template>
    </b-table>
    <!-- pagination -->
    <div class="mx-2 d-none d-md-table">
      <b-row>
        <b-col cols="12" md="2" class="mb-2">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">
              {{ $t("perPage") }}
            </label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              @change="handlePerPageChange"
              class="w-50"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="10"
          class="d-flex align-items-center justify-content-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            pills
            @change="handlePageChange"
            first-number
            last-number
          >
            <template #prev-text>
              <feather-icon size="18" icon="ChevronLeftIcon" />
            </template>
            <template #next-text>
              <feather-icon size="18" icon="ChevronRightIcon" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <!-- List for mobile devices -->
    <div id="list-container" class="d-block d-md-none mt-1 list-container">
      <b-list-group>
        <b-list-group-item
          v-for="item in items"
          :key="item.idSubscriptionCompany"
          class="d-flex flex-column align-items-start border border-primary rounded mb-1"
        >
          <div class="d-flex w-100 justify-content-between mb-1">
            <strong>
              {{ item.nameSubscription }}
              <b-badge pill :variant="tagsColor(item.active)">
                <span>{{ item.active ? "Activo" : "Inactivo" }}</span>
              </b-badge></strong
            >
          </div>
          {{ $t(labelHeader("name_company")) }} :
          {{ item.nameCompany != null ? item.nameCompany : "-" }}
          <br />
          {{ $t(labelHeader("start_date")) }} :
          {{
            item.startDate != null
              ? new Date(item.startDate).toLocaleDateString("en-GB")
              : "-"
          }}
          <br />
          {{ $t(labelHeader("endd_date")) }} :
          {{
            item.endDate != null
              ? new Date(item.endDate).toLocaleDateString("en-GB")
              : "-"
          }}
          <br />
        </b-list-group-item>
        <b-list-group-item v-if="items.length == 0" class="text-center">
          {{ $t("notRegister") }}
        </b-list-group-item>
        <b-list-group-item v-if="loading" class="text-center">
          <b-spinner variant="success"></b-spinner>
        </b-list-group-item>
      </b-list-group>
    </div>
  </b-card>
</template>

<script>
import _ from "lodash";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BRow,
  BCol,
  BButton,
  BTable,
  BPagination,
  BToast,
  BSpinner,
  BBadge,
  BTooltip,
  BFormSelect,
  BFormGroup,
  BCardText,
  BCardBody,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Ripple from "vue-ripple-directive";
import { getParams } from "@core/utils/utils";
import Filterss from "../components/filters/Filterss.vue";
import {
  allCompanyMemberships,
  confirmatedPaymentSubcription,
} from "@core/api/request/membership";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BRow,
    BCol,
    BButton,
    BTable,
    BPagination,
    BToast,
    BSpinner,
    BBadge,
    BFormSelect,
    BFormGroup,
    BTooltip,
    Filterss,
    BCardText,
    BCardBody,
    ValidationProvider,
    ValidationObserver,
    BListGroup,
    BListGroupItem,
  },
  directives: {
    "b-tooltip": BTooltip,
    Ripple,
  },
  data: () => ({
    model: "subscriptions",
    loading: false,
    totalRows: 0,
    idSubscription: null,
    idSubscriptionCompany: null,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    hasNextPage: true,
    items: [],
    headVariant: "light",
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    companyGuid: null,
    subscriptions: [],
    fields: [
      { label: "name_subscription", key: "nameSubscription", sortable: true },
      { label: "name_company", key: "nameCompany", sortable: true },
      {
        label: "start_date",
        key: "startDate",
        sortable: true,
        formatter: (value, key, item) => {
          let date;
          if (item.startDate != null) {
            date = new Date(item.startDate).toLocaleDateString("en-GB");
          } else {
            date = " - ";
          }
          return date;
        },
      },
      {
        label: "endd_date",
        key: "endDate",
        sortable: true,
        formatter: (value, key, item) => {
          let date;
          if (item.endDate != null) {
            date = new Date(item.endDate).toLocaleDateString("en-GB");
          } else {
            date = " - ";
          }
          return date;
        },
      },
      { label: "active", key: "active", sortable: false },
    ],
    fieldsToFilters: [
      {
        name: "name",
        type: "text",
        placeholder: "name",
        type: "search",
        visible: true,
      },
    ],
  }),

  watch: {},
  computed: {},
  created() {
    this.loadMemberships();
  },
  async mounted() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    async loadMemberships() {
      try {
        this.loading = true;
        const params = this.chargeParams();

        const [membershipsResp] = await Promise.all([
          allCompanyMemberships(params),
        ]);

        const memberships = _.get(membershipsResp, "data");
        this.items = memberships?.items || [];
        this.totalRows = memberships?.totalRows || 0;
        this.hasNextPage =
          memberships?.currentPage < memberships?.totalPages || 0;
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error loading data", error.message);
      } finally {
        this.loading = false;
      }
    },
    loadMembershipsInfinity() {
      if (!this.hasNextPage) return;
      try {
        this.loading = true;
        const param = this.chargeParams();
        allCompanyMemberships(param)
          .then((resp) => {
            const data = _.get(resp, "data", []);
            if (Array.isArray(data?.items)) {
              this.items = [...this.items, ...data?.items];
            }
            this.totalRows = data?.totalRows || 0;
            this.hasNextPage = data?.currentPage < data?.totalPages || 0;
            this.loading = false;
          })
          .catch((error) => {
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
            console.log("error", error.message);
          });
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error loading data", error.message);
      }
    },
    label(field) {
      return `pages.membership.table.${field}`;
    },
    labelHeader(field) {
      return `pages.membership.table.tableHeader.${field}`;
    },
    tagsColor(status) {
      if (status) return "light-success";
      else return "light-danger";
    },
    chargeParams() {
      const arrParams = [];
      arrParams.push(`page,${this.currentPage}`);
      arrParams.push(`rows,${this.perPage}`);
      if (this.active) arrParams.push(`active,${this.active}`);

      return getParams(arrParams);
    },
    async handleScroll() {
      const container = document.getElementById("list-container");
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        this.currentPage++;
        await this.loadMembershipsInfinity();
      }
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.hasNextPage = true;
      this.loadMemberships();
    },
    handlePerPageChange() {
      this.loadMemberships();
    },
    onInfo() {
      console.log("Displaying tutorial info");
    },
    confirmationMembership() {
      const data = {
        idSubscriptionPayment: this.idSubscription,
        idSubscriptionCompany: this.idSubscriptionCompany,
      };
      confirmatedPaymentSubcription(data)
        .then((resp) => {})
        .catch((error) => {
          console.log("error", error);
        });
    },
    message(title, text, icon) {
      this.$swal({
        title,
        text,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },
    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
    applyFilters(filters) {
      this.appliedFilters = filters;

      this.loadSubscriptionsWithFilters(filters.name);
    },
    resetFilters() {
      this.appliedFilters = {};

      this.loadSubscriptions();
    },
  },
};
</script>
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.list-container {
  height: 60vh !important; /* Ajusta el alto según tus necesidades */
  overflow-y: auto;
}
</style>
